/* global gtag */
import React, { useCallback, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { useDispatch, useMappedState } from 'redux-react-hook';
import _delay from 'lodash/delay';
import _isEmpty from 'lodash/isEmpty';
import { getNextQuestionAfterLogin } from 'redux/actions/consultation';
import LoginProvider from 'styles/blocks/login';
import media from 'styles/media';
import { Spinner } from 'styles/blocks/spinner';
import { STRINGS } from 'config';

const LoginLoadingContainer = styled(LoginProvider)`
  width: 100%;
  box-sizing: border-box;
  padding: 30px 12%;
  ${media.smallAndBelow`
    padding: 10px 3.5%;
    width: 100%;
  `}
`;

const spinnerStyles = css`
  align-self: flex-start;
  animation-delay: 0s;
`;

const dotStyles = css`
  background-color: ${props => props.theme.buttonPrimaryBackgroundColor};
`;

export function LoginLoading() {
  const mapState = useCallback(state => ({
    patientDetails: state.loginReducer.patientDetails,
    isVerified: state.loginReducer.isVerified,
    isLoggedIn: state.loginReducer.isLoggedIn,
    treatmentCategory: state.consultationReducer.treatmentCategory,
    responseType: state.consultationReducer.responseType,
    federatedLoginProvider: state.consultationReducer.federatedLoginProvider,
  }), []);
  const { patientDetails, isVerified, isLoggedIn, treatmentCategory, responseType, federatedLoginProvider } = useMappedState(mapState);

  // Create actions
  const dispatch = useDispatch();

  useEffect(() => {
    if (!_isEmpty(patientDetails)) {
      dispatch(getNextQuestionAfterLogin({
        patientDetails: { ...patientDetails, phoneNumber: patientDetails.contactPhoneNumber },
        isVerified,
        isLoggedIn,
      }))
        .then(() => {
          if (typeof gtag !== 'undefined') {
            gtag('event', 'virtual_page_view', {
              event_category: `/virtual/consultation/qpp/${treatmentCategory || ''}/${federatedLoginProvider}/success`,
              event_label: responseType,
              value: 1,
            });
          }
          dispatch({ type: STRINGS.CONSULTATION_REDUCER.INTERNAL_REDIRECT_REQUEST, payload: 'Removing user details from url' });
        })
        .then(() => _delay(() => window.location.assign(window.location), 3000));
    }
  }, [dispatch, patientDetails, isVerified, isLoggedIn, responseType, treatmentCategory, federatedLoginProvider]);

  return (
    <LoginLoadingContainer>
      <LoginProvider.Header>You&apos;ve logged in successfully</LoginProvider.Header>
      <LoginProvider.Text>We&apos;re redirecting you to your request</LoginProvider.Text>
      <Spinner isVisible dotStyles={dotStyles} spinnerStyles={spinnerStyles} />
    </LoginLoadingContainer>
  );
}
